export default __webpack_public_path__ + "77edec65aaf90b567d67f88ad94f431b.jpg";